import { render, staticRenderFns } from "./BottomHeader.vue?vue&type=template&id=717dc573&scoped=true&"
import script from "./BottomHeader.vue?vue&type=script&lang=js&"
export * from "./BottomHeader.vue?vue&type=script&lang=js&"
import style0 from "./BottomHeader.vue?vue&type=style&index=0&id=717dc573&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717dc573",
  null
  
)

export default component.exports